import * as React from "react";
import {ThemeProvider} from "@emotion/react";
import {carsTheme} from "@rw/themes";

export const CarsThemeProvider: React.FC<{children?: React.ReactNode}> = (props) => {
    return <ThemeProvider theme={carsTheme}>{props.children}</ThemeProvider>;
};
